<script>
    export let id;
    export let imageURL;
    export let cardTitle;
    export let cardText;

</script>


<div id="{id}" class="card m-0">
    {#if imageURL!=undefined}
        
        <img src="{imageURL}" class="card-img" alt="Imagen de {cardTitle}">
        
    {/if}
    <div class="card-body border-0 card-img-overlay bg-transparent-dark text-white">
        <h5 class="card-title">{cardTitle}</h5>
        <p class="card-text text-start">{cardText}</p>
    </div>
    <!--<div class="card-footer border-0 p-0 position-relative ">
        <button class="rounded btn-azul-consulta w-100">Leer más</button>
    </div>-->
</div>

<style>
    .card-img{
        height: 15rem;
    }
    .bg-transparent-dark{
        background: rgba(0,0,0,0.5);
    }
    .bg-transparent-dark:hover{
        background: rgba(0,0,0,0.25);
    }
    
</style>